// extracted by mini-css-extract-plugin
export default {"faculty":"Faculty_faculty__1xK0w","hidden":"Faculty_hidden__m1H9e","grid":"Faculty_grid__4YSlu","grid_box":"Faculty_grid_box__-rkXP","read_button":"Faculty_read_button__XkC3A"};